import React from "react";
import PropTypes from "prop-types";
import {FaSolidIcon} from "../../../../FontAwesomeIcons";
import moment from "moment";
import {AudioPlayer} from "./AudioPlayer/AudioPlayer";

export function AudioMessage({isMine, isLast, messageData, getMediaContentUrlAPI, ...props}) {
    const sendTime = moment(messageData.data_creazione).format('HH:mm');
    const mediaUrl = getMediaContentUrlAPI(messageData.id_messaggio);

    return (
        <React.Fragment>
            <div className={"d-flex " + (isMine ? 'justify-content-end mine' : 'yours')}>
                <div className={"message " + (isLast ? 'last' : '')}>
                    {!!props.sender && props.sender}
                    <AudioPlayer src={mediaUrl} type={messageData.metadata.mime_type} />
                    <div className={"metadata"}>
                        {sendTime}&nbsp;
                        {
                            isMine &&
                            <FaSolidIcon name={messageData.letto === '1' ? 'check-double' : 'check'}/>
                        }
                    </div>
                </div>
            </div>
        </React.Fragment>
    )
}

AudioMessage.propTypes = {
    isMine: PropTypes.bool,
    isLast: PropTypes.bool,
    messageData: PropTypes.object.isRequired,
    getMediaContentUrlAPI: PropTypes.func.isRequired,
    sender: PropTypes.element
}
